const SuggestStructure = {
  userId: "",
  useruuid: "",
  userName: "",
  userimage: "",
  profileId: "",
  posts: [
    {
      postId: "", // Unique Post ID
      descriptions: "",
      timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
      location: "", // Location of the post
      sharedBy: "",
      medias: [
          {
              mediatype: "",
              mediaurl: "",
          }
      ],
    },
  ],
};

export default SuggestStructure;
